export default "__VITE_ASSET__BuEY92O8__"